/* NuBest footer v2.1 — behaviour for sections/nb-footer.liquid
   1. Mobile accordion for the link columns (below 1024px the heading is a button; CSS decides when it shows).
   2. "Offer terms apply." opens the offer-terms popup (a dialog, not a page): focus moves into it, Tab stays inside,
      Esc / the X / a click on the dark backdrop closes it and focus goes back to the link that opened it.
   The email signup needs no code here: it is the theme's own Klaviyo form (T4SThemeSP.PlatFormMail).
   ES5 on purpose (older iOS Safari). */
(function () {
  'use strict';

  var LOCK_CLASS = 'nbf-offer-lock';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function initAccordion(root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.nbf-acc-btn') : null;
      if (!btn || !root.contains(btn)) return;
      var list = document.getElementById(btn.getAttribute('aria-controls'));
      if (!list) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (open) list.classList.remove('is-open');
      else list.classList.add('is-open');
    });
  }

  function focusables(box) {
    var all = box.querySelectorAll('a[href], button:not([disabled])');
    var out = [];
    for (var i = 0; i < all.length; i++) {
      if (all[i].offsetWidth || all[i].offsetHeight || all[i].getClientRects().length) out.push(all[i]);
    }
    return out;
  }

  function initOffer(root) {
    var openers = root.querySelectorAll('[data-nbf-offer-open]');
    var dlg = root.querySelector('#nbf-offer');
    if (!openers.length || !dlg) return;

    // A previous render (theme editor re-render) may have left an old copy on <body>; keep only the fresh one.
    var stale = document.querySelectorAll('body > #nbf-offer');
    for (var s = 0; s < stale.length; s++) {
      if (stale[s] !== dlg && stale[s].parentNode) stale[s].parentNode.removeChild(stale[s]);
    }
    // Out of the footer section so that it can cover the whole page and no ancestor transform/overflow clips it.
    document.body.appendChild(dlg);

    var lastFocus = null;
    var card = dlg.querySelector('.nbf-offer-card');

    function isOpen() { return !dlg.hasAttribute('hidden'); }

    function open() {
      if (isOpen()) return;
      lastFocus = document.activeElement;
      dlg.removeAttribute('hidden');
      document.documentElement.className += ' ' + LOCK_CLASS;
      var x = dlg.querySelector('.nbf-offer-x');
      // The dialog is display:none until the line above; focus after it is laid out.
      if (x && x.focus) x.focus();
      else if (card && card.focus) card.focus();
    }

    function close() {
      if (!isOpen()) return;
      dlg.setAttribute('hidden', '');
      document.documentElement.className = document.documentElement.className.replace(new RegExp('(^|\\s)' + LOCK_CLASS + '(?=\\s|$)', 'g'), '').replace(/^\s+|\s+$/g, '');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      lastFocus = null;
    }

    for (var i = 0; i < openers.length; i++) {
      openers[i].addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    }

    dlg.addEventListener('click', function (e) {
      var t = e.target;
      while (t && t !== dlg) {
        if (t.hasAttribute && t.hasAttribute('data-nbf-offer-close')) { close(); return; }
        t = t.parentNode;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      var key = e.key || e.keyCode;
      if (key === 'Escape' || key === 'Esc' || key === 27) {
        e.preventDefault();
        close();
        return;
      }
      if (key === 'Tab' || key === 9) {
        var f = focusables(dlg);
        if (!f.length) { e.preventDefault(); return; }
        var first = f[0], last = f[f.length - 1], a = document.activeElement;
        if (!dlg.contains(a)) { e.preventDefault(); first.focus(); }
        else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  // 27 Oct 2026: accessibility options. The store runs the Consentmo GDPR web accessibility widget with its floating icon
  // hidden (Consentmo > Web Accessibility > "Hide widget until activated"). Any [data-nb-a11y-open] button (footer legal row,
  // /pages/accessibility) or an old a[href$="#csm-ada-popover"] link opens the panel through Consentmo's storefront API:
  // window.Consentmo.accessibility.open() + document events consentmo:accessibilityReady / Opened / Closed.
  // If the SDK is not ready after 4 s, the button falls back to /pages/accessibility. Focus returns to the button on close.
  function initA11y() {
    if (window.__nbA11y) return;
    window.__nbA11y = true;
    var SEL = '[data-nb-a11y-open], a[href$="#csm-ada-popover"]';
    var EV_READY = 'consentmo:accessibilityReady', EV_OPEN = 'consentmo:accessibilityOpened', EV_CLOSED = 'consentmo:accessibilityClosed';
    var last = null;
    function api() {
      var c = window.Consentmo;
      return c && c.accessibility && typeof c.accessibility.open === 'function' ? c.accessibility : null;
    }
    function sync(on) {
      var list = document.querySelectorAll('[data-nb-a11y-open]');
      for (var i = 0; i < list.length; i++) list[i].setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    function openFrom(btn) {
      var a = api();
      if (!a) return false;
      last = btn;
      try { a.open(); } catch (_) { return false; }
      return true;
    }
    function fallback(btn) {
      var href = btn.getAttribute('data-nb-a11y-fallback') || '/pages/accessibility';
      if (location.pathname !== href) location.href = href;
    }
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest(SEL) : null;
      if (!btn) return;
      e.preventDefault();
      if (openFrom(btn)) return;
      var done = false;
      btn.setAttribute('aria-busy', 'true');
      function finish() {
        if (done) return;
        done = true;
        btn.removeAttribute('aria-busy');
        if (!openFrom(btn)) fallback(btn);
      }
      document.addEventListener(EV_READY, finish, { once: true });
      setTimeout(finish, 4000);
    });
    document.addEventListener(EV_OPEN, function () { sync(true); });
    // Consentmo hands focus back, then drops it to <body> about 350 ms later (close animation),
    // so focus is put back on the button again after the animation if nothing else took it.
    document.addEventListener(EV_CLOSED, function () {
      sync(false);
      var btn = last;
      last = null;
      if (!btn || !document.contains(btn)) return;
      function back() {
        var a = document.activeElement;
        if (a === btn) return;
        if (!a || a === document.body || a === document.documentElement || (a.tagName && a.tagName.toLowerCase() === 'csm-web-accessibility')) {
          try { btn.focus({ preventScroll: true }); } catch (_) { try { btn.focus(); } catch (__) {} }
        }
      }
      back();
      setTimeout(back, 500);
      setTimeout(back, 1000);
    });
  }
  initA11y();

  ready(function () {
    var root = document.querySelector('[data-nbf]');
    if (!root) return;
    // Idempotent: if this file is ever loaded twice (theme editor re-render, a second <script> tag), bind once.
    if (root.getAttribute('data-nbf-ready') === '1') return;
    root.setAttribute('data-nbf-ready', '1');
    initAccordion(root);
    initOffer(root);
  });
})();
